<template>
   <div class="filter">
      <Delete :delete_message="delete_message" :show="show_delete_modal" @close="$store.commit('show_delete_modal',false)" @delete="deleteFilter()"/>

      <Modal :show="show_create_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_create_modal',false)">
         <template slot="title">
            <div class="title">{{FilterModel.forms.addFilter.title}}</div>
            <div class="subtitle">{{FilterModel.forms.addFilter.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="FilterModel.forms.addFilter.name" 
                  :forms="FilterModel.forms.addFilter.forms" 
                  :form_data="FilterModel.forms.addFilter.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="addFilter({ref: $refs[FilterModel.forms.addFilter.name]})" :disabled="loading">
                     Create <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Modal :show="show_edit_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">{{FilterModel.forms.editFilter.title}}</div>
            <div class="subtitle">{{FilterModel.forms.editFilter.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="FilterModel.forms.editFilter.name" 
                  :forms="FilterModel.forms.editFilter.forms" 
                  :form_data="FilterModel.forms.editFilter.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="updateFilter({ref: $refs[FilterModel.forms.editFilter.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Modal :show="show_edit_options" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_edit_options',false)">
         <template slot="title">
            <div class="title">{{FilterModel.forms.edit_options.title}}</div>
            <div class="subtitle">{{FilterModel.forms.edit_options.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="FilterModel.forms.edit_options.name" 
                  :forms="FilterModel.forms.edit_options.forms" 
                  :form_data="FilterModel.forms.edit_options.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="updateFilter({ref: $refs[FilterModel.forms.edit_options.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <div class="top-actions clearfix">
         <div class="btn btn-primary btn-r" @click="$store.commit('show_create_modal',true)">
            Add Filter <i class="fa fa-plus"></i>
         </div>
      </div>
      
      <Table v-bind="FilterModel.tables.filter.props" :data="filters" @on-action="handleActions"/>
   </div>
</template>

<script>
import filter from "./filter.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('filter')
      Event.$off('select-field-changed')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('filter',filter,this.$store)
      Event.$on('select-field-changed',(payload) => {
         this.selectFieldChanged(payload)
      })
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   computed: {
      ...mapGetters([
         'FilterModel',
         'filters',
         'show_create_modal',
         'show_edit_modal',
         'show_edit_options',
         'show_delete_modal',
         'loading',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'addFilter',
         'selectFieldChanged',
         'deleteFilter',
         'updateFilter',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('filter',filter,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .filter{
      
   }
</style>